import React from "react";
import { classNames } from "@greeter/util";
import css from "./TextInput.module.scss";

function preventWheelNumericInputChanges(
  ev: React.WheelEvent<HTMLInputElement>
) {
  // Prevent the input value change
  ev?.currentTarget?.blur();
  // Refocus immediately, on the next tick (after the current function is done)
  setTimeout(() => {
    ev?.currentTarget?.focus();
  }, 0);
}

export type TextInputProps = React.ComponentProps<"input">;

export function TextInput({
  className,
  onWheelCapture,
  ...props
}: TextInputProps) {
  return (
    <input
      {...classNames(css.TextInput, className)}
      onWheelCapture={preventWheelNumericInputChanges}
      {...props}
    />
  );
}
